import { render } from "./legoRadioExtend.vue?vue&type=template&id=49c1a726&scoped=true"
import script from "./legoRadioExtend.vue?vue&type=script&lang=js"
export * from "./legoRadioExtend.vue?vue&type=script&lang=js"

import "./legoRadioExtend.vue?vue&type=style&index=0&id=49c1a726&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c1a726"],['__file',"src/components/lego/extend/legoRadioExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49c1a726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49c1a726', __exports__)) {
    api.reload('49c1a726', __exports__)
  }
  
  module.hot.accept("./legoRadioExtend.vue?vue&type=template&id=49c1a726&scoped=true", () => {
    api.rerender('49c1a726', render)
  })

}


export default __exports__